
export const validate = (values,t) => {
    
    let errors = {};

    // Validate email field
    if (!values.email) {
        errors.email = t("email_required");
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email =  t("email_invalid");
    }

    // Validate password field
    if (!values.password) {
        errors.password = t("password_required");
    } else if (values.password.length < 3) {
        errors.password =  t("password_min_length");
    }

    return errors;
};
